import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ProductListItem extends Component{

	handleClick = (e) => {
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;
	};

	renderImage = (product) => {
		if(product.imageUrls === undefined || product.imageUrls.length > 0){
			return (
				<div className="product-list__item-image"
				     style={{backgroundImage: 'url(' + product.imageUrls[0] + ')'}}
				     title={product.name} />
			);
		}

		return (
			<div className="product-list__item-image product-list__item-image--no-image"
			     title={product.name} />
		);
	};

	render(){
		const { product, localizePath } = this.props;
		return (
			<div className="product-list__item">
				<Link to={localizePath("/product/"+product.url)} onClick={this.handleClick}>
					{this.renderImage(product)}
					<h3 className="product-list__item-title">{product.name}</h3>
				</Link>
			</div>
		);
	};
}

export default ProductListItem;


// WEBPACK FOOTER //
// ./src/components/common/ProductListItem.js